export var isIOSDevice = function isIOSDevice() {
  var _window = window,
      navigator = _window.navigator,
      MSStream = _window.MSStream;
  var userAgent = navigator.userAgent,
      maxTouchPoints = navigator.maxTouchPoints;
  return !MSStream && (/iPad|iPhone|iPod/.test(userAgent) || /Macintosh/.test(userAgent) && maxTouchPoints > 2);
};
export var isAndroidDevice = function isAndroidDevice() {
  return /Android/.test(window.navigator.userAgent);
};
export var isChromebook = function isChromebook() {
  return /CrOS/.test(window.navigator.userAgent);
};
export var isMobileDevice = function isMobileDevice() {
  return isAndroidDevice() || isIOSDevice();
};